module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../node_modules/coffee-loader/index.js!./pt-PT.coffee"));
	}, "locale/pt-PT");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=locale/[name]!./app/locale/pt-PT.coffee
// module id = 294
// module chunks = 97